import React, {useEffect, useState} from "react";
import {useWatch} from "react-hook-form";
import {css} from "@emotion/react";

import {DsTooltip} from "@pg-design/floating-module";
import {calculateRemSize, mb, ph} from "@pg-design/helpers-css-strings";
import {InfoIcon} from "@pg-design/icons-module";
import {IRange} from "@pg-design/inputs-module";
import {Text} from "@pg-design/text";

import {BudgetField} from "../../../real_estate/components/fields/BudgetField";
import {Currency} from "../../../types/Currency";
import {usePriceRanges} from "../../hooks/use_price_ranges";

interface IProps {
    onChange?: (name: string, value?: IRange<string> | number) => void;
    isInModal?: boolean;
    currency?: Currency;
    inputVariant?: "row" | "column";
    radioGroupClassName?: string;
    radioClassName?: string;
    fieldNames?: {radio: string; credit: string; total: string};
}

export enum BudgetFieldsNames {
    RADIO = "filterBudget",
    TOTAL = "budgetTotal",
    CREDIT = "budgetCredit"
}

export const FilterBudget = (props: IProps) => {
    const {fieldNames = {radio: BudgetFieldsNames.RADIO, credit: BudgetFieldsNames.CREDIT, total: BudgetFieldsNames.TOTAL}} = props;
    const totalBudget = useWatch({name: fieldNames.total});
    const creditInstalment = useWatch({name: fieldNames.credit});
    const radioWatcher = useWatch({name: fieldNames.radio});
    const {maxPrice} = usePriceRanges();
    const [renderField, setRenderField] = useState(false);

    useEffect(() => {
        // renderField state and this useEffect is use to fix thumb style not assign correctly on mount in modal
        if (props.isInModal) {
            setTimeout(() => setRenderField(true), 550);
        } else {
            setRenderField(true);
        }
    }, []);

    useEffect(() => {
        if (radioWatcher === "total") {
            props.onChange?.("price", {lower: "", upper: totalBudget});
            props.onChange?.("instalment", undefined);
        }
        if (radioWatcher === "monthly") {
            props.onChange?.("instalment", creditInstalment);
            props.onChange?.("price", {lower: "", upper: ""});
        }
    }, [totalBudget, creditInstalment, radioWatcher]);

    return (
        <div css={FilterBudgetWrapper}>
            {renderField && (
                <BudgetField
                    radioName={fieldNames.radio}
                    type="switch"
                    totalInputName={fieldNames.total}
                    monthlyInputName={fieldNames.credit}
                    totalMax={maxPrice}
                    useBudgetDynamicStep
                    monthlyTitleRender={() => (
                        <div css={monthlyTitle} onClick={(e) => e.stopPropagation()}>
                            <Text variant="info_txt_1">Rata kredytu</Text>
                            <div onClick={(e) => e.stopPropagation()}>
                                <DsTooltip
                                    popover="Kalkulacja raty kredytu opiera się na następujących założeniach: 20% wkładu własnego, oprocentowaniu na poziomie 7% oraz okresie kredytowania wynoszącym 30 lat."
                                    type="success"
                                    css={messageTooltip}
                                >
                                    {({refs, getReferenceProps}) => (
                                        <div ref={refs.setReference} {...getReferenceProps()}>
                                            <InfoIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" />
                                        </div>
                                    )}
                                </DsTooltip>
                            </div>
                        </div>
                    )}
                    currency={props.currency}
                    radioGroupClassName={props.radioGroupClassName}
                    radioClassName={props.radioClassName}
                    inputVariant={props.inputVariant}
                />
            )}
        </div>
    );
};

const FilterBudgetWrapper = css`
    ${ph(1)};
    ${mb(2)};
    position: relative;
`;

const monthlyTitle = css`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: ${calculateRemSize(1)};
`;

const messageTooltip = css`
    z-index: 10000;
    max-width: 360px;
`;
import React, {useEffect, useState} from "react";
import {useWatch} from "react-hook-form";
import {css} from "@emotion/react";

import {DsTooltip} from "@pg-design/floating-module";
import {calculateRemSize, mb, ph} from "@pg-design/helpers-css-strings";
import {InfoIcon} from "@pg-design/icons-module";
import {IRange} from "@pg-design/inputs-module";
import {Text} from "@pg-design/text";

import {BudgetField} from "../../../real_estate/components/fields/BudgetField";
import {Currency} from "../../../types/Currency";
import {usePriceRanges} from "../../hooks/use_price_ranges";

interface IProps {
    onChange?: (name: string, value?: IRange<string> | number) => void;
    isInModal?: boolean;
    currency?: Currency;
    inputVariant?: "row" | "column";
    radioGroupClassName?: string;
    radioClassName?: string;
    fieldNames?: {radio: string; credit: string; total: string};
}

export enum BudgetFieldsNames {
    RADIO = "filterBudget",
    TOTAL = "budgetTotal",
    CREDIT = "budgetCredit"
}

export const FilterBudget = (props: IProps) => {
    const {fieldNames = {radio: BudgetFieldsNames.RADIO, credit: BudgetFieldsNames.CREDIT, total: BudgetFieldsNames.TOTAL}} = props;
    const totalBudget = useWatch({name: fieldNames.total});
    const creditInstalment = useWatch({name: fieldNames.credit});
    const radioWatcher = useWatch({name: fieldNames.radio});
    const {maxPrice} = usePriceRanges();
    const [renderField, setRenderField] = useState(false);

    useEffect(() => {
        // renderField state and this useEffect is use to fix thumb style not assign correctly on mount in modal
        if (props.isInModal) {
            setTimeout(() => setRenderField(true), 550);
        } else {
            setRenderField(true);
        }
    }, []);

    useEffect(() => {
        if (radioWatcher === "total") {
            props.onChange?.("price", {lower: "", upper: totalBudget});
            props.onChange?.("instalment", undefined);
        }
        if (radioWatcher === "monthly") {
            props.onChange?.("instalment", creditInstalment);
            props.onChange?.("price", {lower: "", upper: ""});
        }
    }, [totalBudget, creditInstalment, radioWatcher]);

    return (
        <div css={FilterBudgetWrapper}>
            {renderField && (
                <BudgetField
                    radioName={fieldNames.radio}
                    type="switch"
                    totalInputName={fieldNames.total}
                    monthlyInputName={fieldNames.credit}
                    totalMax={maxPrice}
                    useBudgetDynamicStep
                    monthlyTitleRender={() => (
                        <div css={monthlyTitle} onClick={(e) => e.stopPropagation()}>
                            <Text variant="info_txt_1">Rata kredytu</Text>
                            <div onClick={(e) => e.stopPropagation()}>
                                <DsTooltip
                                    popover="Kalkulacja raty kredytu opiera się na następujących założeniach: 20% wkładu własnego, oprocentowaniu na poziomie 7% oraz okresie kredytowania wynoszącym 30 lat."
                                    type="success"
                                    css={messageTooltip}
                                >
                                    {({refs, getReferenceProps}) => (
                                        <div ref={refs.setReference} {...getReferenceProps()}>
                                            <InfoIcon size="1.6" wrapperSize="1.6" wrapperColor="transparent" />
                                        </div>
                                    )}
                                </DsTooltip>
                            </div>
                        </div>
                    )}
                    currency={props.currency}
                    radioGroupClassName={props.radioGroupClassName}
                    radioClassName={props.radioClassName}
                    inputVariant={props.inputVariant}
                />
            )}
        </div>
    );
};

const FilterBudgetWrapper = css`
    ${ph(1)};
    ${mb(2)};
    position: relative;
`;

const monthlyTitle = css`
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    gap: ${calculateRemSize(1)};
`;

const messageTooltip = css`
    z-index: 10000;
    max-width: 360px;
`;
